import React, {PropTypes} from 'react';
import moment from 'moment';
import {formatCurrency} from 'shared/util/formatCurrency';
Number.prototype.formatCurrency = formatCurrency;

const CaptainPaymentEntryListItem = ({
  entryId,
  reservationNumber,
  eventName,
  squadDateTime,
  amountApplied,
  onEntryLinkClick
}) => (
    <div style={{ "margin-bottom": -10 }}>
      <div className="list-group-item-labeled">
    <div className="list-group-item-labeled-child has-link"
        style={{ width: 235, "margin-bottom": 10}}
      onClick={() => onEntryLinkClick(entryId)}>
      <span>{'Reservation No.'}</span>
      <span>{reservationNumber || 'N/A'}</span>
    </div>
    <div className="list-group-item-labeled-child"
        style={{ width: 125, "margin-bottom": 10}}>
      <span>{'Amount Applied'}</span>
      <span>{`$${amountApplied.formatCurrency(2)}`}</span>
    </div>
    <div className="list-group-item-labeled-child"
        style={{ width: 250, "margin-bottom": 10}}>
      <span>{'Squad Time'}</span>
      <span>{squadDateTime ? `${moment.parseZone(squadDateTime).format('MMM Do, YYYY, hh:mm A')}` : '-'}</span>
    </div>
    <div className="list-group-item-labeled-child"
        style={{ width: 250, "margin-bottom": 10}}>
      <span>{'Event Name'}</span>
      <span>{eventName}</span>
    </div>
  </div>
    </div>
);

CaptainPaymentEntryListItem.propTypes = {
  entryId: PropTypes.string,
  reservationNumber: PropTypes.string,
  eventName: PropTypes.string,
  squadDateTime: PropTypes.string,
  amountApplied: PropTypes.number,
  onEntryLinkClick: PropTypes.func
};

CaptainPaymentEntryListItem.defaultProps = {
  entryId: '',
  reservationNumber: '',
  eventName: '',
  squadDateTime: '',
  amountApplied: 0
};

export default CaptainPaymentEntryListItem;



// WEBPACK FOOTER //
// ./src/features/admin/captainDetail/CaptainPaymentEntryListItem.jsx